<script>
export default {
  data() {
    return {
      empresas: [
        { nome: 'CEMITERIO MEMORIAL PARQUE MACEIO', link: "https://www.adiau.net/validacao/index.php?ipc=1692704302&id=169&token=e5db59c932f6151b8820b1644bc5c72b&color1=******&color2=******&color3=******&color4=******&color5=******#" },
        { nome: 'PREVIDA', link: "https://www.adiau.net/validacao/index.php?ipc=1652704302&id=165&token=750ed4ec57a6819ac76b18a5910553aa&color1=******&color2=******&color3=******&color4=******&color5=******#" },
        { nome: 'CEMITERIO PREVIDA', link: "https://www.adiau.net/validacao/index.php?ipc=1672700300&id=167&token=cc5028bc7b3dfd2e3470f14dc274947d&color1=******&color2=******&color3=******&color4=******&color5=******#" },
        { nome: 'CEMITERIO PARQUE DO AGRESTE', link: "https://www.adiau.net/validacao/index.php?ipc=1662706307&id=166&token=d407e19a4d906a4c968ced892851dbc6&color1=******&color2=******&color3=******&color4=******&color5=******#" },
        { nome: 'CEMITERIO PARQUE DAS FLORES', link: "https://www.adiau.net/validacao/index.php?ipc=1682704302&id=168&token=7a735cbd238622fbf58166ab63865aba&color1=9fc1d7&color2=******&color3=******&color4=******&color5=******#" }
      ],
      empresaData: ''
    };
  },
  computed: {
    empresaLink() {
      const empresaEncontrada = this.empresas.find(e => e.nome === this.empresaData);
      return empresaEncontrada ? empresaEncontrada.link : 'https://veloriovirtual.grupoparque.com.br/';
    }
  },
  mounted() {
    this.empresaData = this.$route.query.empresaQuery;
  }
};
</script>

<template>
  <div class="iframe-container">
    <iframe :src="empresaLink" width="100%" height="100%" frameborder="0" allowfullscreen></iframe>
  </div>
</template>

<style scoped>
.iframe-container {
  width: 100%;
  height: 100vh;
}
</style>
